import ContactSection from "../components/ContactSection";
import { useApp } from "../context/AppContext";

export default function Contact() {
  const { settings, L } = useApp();
  const c = settings?.contact || {};
  return (
    <div className="pt-28 sm:pt-32">
      <ContactSection />
      {c.map_url && (
        <div className="px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto pb-8">
          <div className="rounded-3xl overflow-hidden cb-card-shadow border border-border">
            <iframe
              title="map"
              className="w-full h-72"
              src={`https://maps.google.com/maps?q=${encodeURIComponent(L(c, "location") || "Riyadh")}&output=embed`}
            />
          </div>
        </div>
      )}
    </div>
  );
}
